import { render } from "./PVC80.vue?vue&type=template&id=557d1fe4&scoped=true"
import script from "./PVC80.vue?vue&type=script&lang=js"
export * from "./PVC80.vue?vue&type=script&lang=js"

import "./PVC80.vue?vue&type=style&index=0&id=557d1fe4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-557d1fe4"]])

export default __exports__